export default __webpack_public_path__ + "static/media/icon-payment-methods-grid.68687164.png";